<template>
    <div>
        <div class="modal hide fade" id="modalCustomerBirthday" tabindex="-1" role="dialog" aria-labelledby="modalCustomerBirthday" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Customer Birthday
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <label for="name" class="col-sm-3 col-form-label text-left">Date</label>
                                    <div class="col-sm-9">
                                        <datetime v-model="date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-success" data-dismiss="modal" @click="save">Get</button>
                        <button type="button" class="btn btn-success" data-dismiss="modal" @click="sendMessage">Get & Send Message</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'CustomerBirthdayModal',
  data () {
    return {
      date: new Date().toISOString()
    }
  },
  methods: {
    save: function () {
      var obj = {
        birthday: this.date,
        send: 'false'
      }
      this.$emit('setBirthday', obj)
    },
    sendMessage: function () {
      var obj = {
        birthday: this.date,
        send: 'true'
      }
      this.$emit('setBirthday', obj)
    }
  }
}
</script>
